import type { ReactElement } from 'react'
import { NotReady } from '@components'
import { useCompany } from '@front/model'
import { CompanyForm } from '../companies_.$companyId/CompanyForm'
import { createFileRoute } from '@tanstack/react-router'

function Company(): ReactElement {
  const { data, isLoading, error, isPlaceholderData, refetch, isFetching } = useCompany()
  if (isLoading || error || !data || isPlaceholderData)
    return <NotReady data={data} error={error} id='company' isLoading={isLoading} />

  return <CompanyForm data={data} isFetching={isFetching} refetch={refetch} />
}

export const Route = createFileRoute('/settings/company/')({
  component: Company,
})
